import { PickerValidDate } from '@mui/x-date-pickers';
import React, { FC } from 'react';

import { Reminder } from '../../../../generated/graphql';

import { ReminderItem } from '../../../../models/reminder';

import RemindersPicker from '../../RemindersPicker';

import * as Styled from './styled';

type Props = {
  dataDateDueMin?: PickerValidDate;
  dataDateDueSaved: PickerValidDate | null;
  dataRemindersSaved: Reminder[];
  requestDateDueRemove?: () => void;
  requestDateDueSave: (
    date: PickerValidDate | null,
    mode: 'date' | 'time',
  ) => void;
  requestRemindersSave: (reminder: ReminderItem[]) => void;
};

/**
 * Setting and removing due date in the compose form
 *
 * @param props                      Props passed to the component
 * @param props.dataDateDueMin       Minimum date that can be selected
 * @param props.dataDateDueSaved     Saved due date
 * @param props.dataRemindersSaved   Saved reminders
 * @param props.requestDateDueRemove Request that the due date is cleared
 * @param props.requestDateDueSave   Request that the due date is saved
 * @param props.requestRemindersSave Request that the reminders are saved
 * @returns                          The component itself
 */
const DueDate: FC<Props> = ({
  dataDateDueMin,
  dataDateDueSaved,
  dataRemindersSaved,
  requestDateDueRemove,
  requestDateDueSave,
  requestRemindersSave,
}) => {
  /**
   * Request that the due dates date is set
   *
   * @param newDate New date to set
   */
  const requestDateChange = (newDate: PickerValidDate | null) => {
    requestDateDueSave(newDate, 'date');
  };

  /**
   * Request that the due dates time is set
   *
   * @param newDate New date to set
   */
  const requestTimeChange = (newDate: PickerValidDate | null) => {
    requestDateDueSave(newDate, 'time');
  };

  return (
    <Styled.Section>
      <Styled.WrapperDueDate>
        <Styled.DatePicker
          autoFocus={true}
          isReadOnly={true}
          minDate={dataDateDueMin}
          onChange={requestDateChange}
          requestClear={requestDateDueRemove}
          value={dataDateDueSaved}
        />
        <Styled.TimePicker
          disabled={dataDateDueSaved === null}
          isReadOnly={true}
          onChange={requestTimeChange}
          value={dataDateDueSaved}
        />
      </Styled.WrapperDueDate>
      <RemindersPicker
        isDisabled={dataDateDueSaved === null}
        reminders={dataRemindersSaved}
        requestOnChange={requestRemindersSave}
      />
    </Styled.Section>
  );
};

export default DueDate;
